import app from '../app.first';

app.MediaFileDurationChecker = class extends app.Component {
   onLoad() {
      this.allowedTypes = {
         'video': [
            /**
             * OGG files
             */
            'video/ogg',

            /**
             * MP4 files
             */
            'video/mp4',

            /**
             * MOV files
             */
            'video/quicktime'
         ],


         'voice': [
            /**
             * MP3 files
             */
            'audio/mpeg',
            'audio/mp3',
            'audio/x-wav',
            'audio/wav',
            'audio/x-m4a',

            /**
             * OGG files
             */
            'audio/ogg',

            // For some reason the ogg audio file I've downloaded
            // as a test has 'video/ogg' mime type
            'video/ogg',

            'application/ogg'
         ]
      };

      /**
       * Maximum File Size: 20 MB
       */
      this.maxFileSize = 20971520;

      this.videoInput = document.getElementById('iy_video_file');
      this.voiceInput = document.getElementById('iy_audio_file');

      this.voiceElement = document.createElement('audio');
      this.videoElement = document.createElement('video');

      this.voiceElement.addEventListener('loadedmetadata', evt => this.checkDuration(evt));
      this.videoElement.addEventListener('loadedmetadata', evt => this.checkDuration(evt));

      this.videoInput.addEventListener('change', evt => this.checkBeforeInput(evt, 'video'));
      this.voiceInput.addEventListener('change', evt => this.checkBeforeInput(evt, 'voice'));
   }

   checkBeforeInput(evt, type) {
      const file = evt.target.files[0];

      if (evt.target.value !== '') {
         if (file.size > this.maxFileSize) {
            this.resetField(type);
            alert('Video file size must be less than 20MB');

            return false;
         }

         if (this.allowedTypes[type].indexOf(file.type) < 0) {
            this.resetField(type);
            alert('Allowed file types for '+ type +' notes: '+ this.allowedTypes[type].join(', '));

            return false;
         }

         // Update the filename label
         let labelId = type === 'voice' ? 'iy_audio_filename' : 'iy_video_filename';
         document.getElementById(labelId).textContent = file.name;

         if (type === 'voice') {
            this.voiceElement.src = URL.createObjectURL(file);

            $('.record-button-container').hide()
            $('.or-container').hide();

         }

         if (type === 'video') {
            this.videoElement.src = URL.createObjectURL(file);
         }
      }
   }


   checkDuration(evt) {
      if (evt.target.tagName === 'AUDIO' && (evt.target.duration < 60 || evt.target.duration > 90)) {

         this.resetField('voice');
         alert('Voice clip must be at least 60 seconds up to 90 seconds');

         return false;

      }

      if (evt.target.tagName === 'VIDEO' && evt.target.duration > 30) {

         this.resetField('video');
         alert('Video clips can only be up to 30 seconds');

         return false;
      }
   }

   resetField(type) {
      if (type === 'voice') {
         this.voiceInput.value = '';
      } else {
         this.videoInput.value = '';
      }

      let labelId = type === 'voice' ? 'iy_audio_filename' : 'iy_video_filename';

      document.getElementById(labelId).innerHTML = '';
   }
}